module.exports = __webpack_public_path__ + "img/yellow-arrow.3b5b4804.svg";